import { useState } from "react";
import { Waves } from "lucide-react";
import { PageCopy, PageIndex, PageMedia } from "../components/site/PagePrimitives";
import "./pages.css";

const modes = [
  {
    id: "reset",
    label: "RESET",
    title: "累了可以慢一点，\n但不用停下来。",
    note: "4 秒吸气 · 6 秒呼气"
  },
  {
    id: "ready",
    label: "READY",
    title: "先稳住呼吸，\n再回到水里。",
    note: "准备好时，再出发"
  }
];

export function MindsetPage() {
  const [mode, setMode] = useState(0);
  const current = modes[mode];

  return (
    <article className={`experience-page page-mindset mindset-${current.id}`} aria-labelledby="mindset-title">
      <PageMedia src="/assets/athlete/mindset-float.webp" alt="" className="page-media--mindset" />
      <PageIndex number="04" label="MINDSET" />
      <PageCopy className="mindset-copy">
        <p className="page-kicker">BREATHE · RESET · RETURN</p>
        <h1 id="mindset-title">
          {current.title.split("\n").map((line) => (
            <span key={line}>{line}</span>
          ))}
        </h1>
        <div className="breath-cue" aria-live="polite">
          <Waves size={24} aria-hidden="true" />
          <span>{current.note}</span>
        </div>
      </PageCopy>
      <div className="mindset-switch" role="group" aria-label="切换心态节奏">
        {modes.map((item, index) => (
          <button
            key={item.id}
            type="button"
            className={mode === index ? "is-active" : ""}
            onClick={() => setMode(index)}
            aria-pressed={mode === index}
          >
            {item.label}
          </button>
        ))}
      </div>
    </article>
  );
}
